<template>
  <h1>Settings</h1>
</template>

<script lang="ts" setup></script>
